import { combineReducers } from 'redux';
// Import reducers
import form from './asset_groups_form_reducer';
import asset_details from './asset_details_form_reducer';

export default combineReducers({
	form,
	asset_details
});
